import { ToolOutlined, DownOutlined } from '@ant-design/icons';
import { Flex, Button, Typography } from 'antd';
import { CauseItem, Percentage } from './styles';
import { Tag } from '../styles';
import { Cause, CloseAction, Routine } from '../../../../types';
import { PossibleCause } from '.';
import { useTheme } from 'styled-components';
import { useState } from 'react';
import RoutineDrawer from '../routineDrawer';
import { useSelector } from 'react-redux';
import { selectRoutines } from '../../../../slices/templates';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '../../../../store';
import { initRoutineConversation } from '../../../../slices/event';

const PossibleCauseItem = ({
  causes,
  cause,
  index,
}: {
  causes: Cause[];
  cause: PossibleCause;
  index: number;
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const routines = useSelector(selectRoutines);
  const theme = useTheme();
  const [showDetails, setShowDetails] = useState(false);
  const [showRoutineDrawer, setShowRoutineDrawer] = useState(false);

  const routine = routines.find(
    (i) => String(i.linkedCause?.causeID) === String(cause.causeID)
  );

  const handleRoutineDrawerClose = (action?: CloseAction) => {
    setShowRoutineDrawer(false);
    if (action === CloseAction.BACK) {
      navigate(-1);
    }
  };

  const handleOpenRoutineDrawer = () => {
    if (routine?.routineID) {
      dispatch(initRoutineConversation(routine.routineID));
      setShowRoutineDrawer(true);
    }
  };

  return (
    <CauseItem key={cause.causeID}>
      <Flex align="center" gap={8}>
        <Percentage className={`level${causes.length - index + 1}`}>
          {(cause.ratio * 100).toFixed(0)}%
        </Percentage>
        <Flex vertical gap={8} flex={1}>
          <Flex gap={4}>
            <Flex flex={1}>
              <p className="title">{cause?.name}</p>
            </Flex>
            <Button
              type="primary"
              ghost
              size="small"
              onClick={handleOpenRoutineDrawer}
              disabled={!routine}
            >
              <ToolOutlined /> Routine
            </Button>
          </Flex>

          <Flex vertical gap={8}>
            <Flex flex={1}>
              <Flex flex={1}>
                <Tag>Tag 1</Tag>
              </Flex>
              <Typography.Text
                type="secondary"
                onClick={() => setShowDetails(!showDetails)}
              >
                More Info{' '}
                <DownOutlined
                  style={{
                    transform: `rotate(${showDetails ? '180deg' : '0'})`,
                    transition: 'ease .2s',
                    fontSize: 10,
                  }}
                />
              </Typography.Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      {showDetails && (
        <Typography.Text style={{ color: theme.antd.colorTextSecondary }}>
          {cause.description || 'No description.'}
        </Typography.Text>
      )}
      <RoutineDrawer
        open={showRoutineDrawer}
        routine={routine as Routine}
        onClose={handleRoutineDrawerClose}
      />
    </CauseItem>
  );
};

export default PossibleCauseItem;
